<template>
  <!-- v-loading="loadingMydevice" -->
  <div class="adminDeviceHome tableloding">
    <!-- :deviceList="deviceList" -->
    <device-nav v-if="showSidebar" @noticeDeviceBox="showDeviceBox" @noticeDataloggerBox="showDataloggerBox"
      @noticeProjectBox="showProjectBox" @noticeRuoRiExportRecordsBox="showRuoRiExportRecordsBoxBox" :currentBtnViewIndexProp="currentBtnViewIndexProp"></device-nav>
    <!-- @noticeDeviceBox="showDeviceBox" -->
    <component :is="shownComponent" v-if="shownComponent" class="article" @noticeSingleBox="showSingleBox"
      @noticeDeviceBoxTwo="showDeviceBox" @noticeDeviceBtnBtnBtn="noticeDeviceBtnBtnBtnBtn"></component>
  </div>
</template>
<script>
// import deviceNo from './deviceno'
// import deviceNav from './sidebar'
import deviceNav from './sidebarmodenew'
// 切换数采器列表
import dataloggerOverview from './datalogger'
// 切换设备列表
import deviceOverview from './device'
// 切换设备详情页
import deviceDetail from './singleBox/deviceindex'
// 切换项目列表
import projectOverview from './project'
// 朔日导出记录
import ruoRiExportRecordsOverview from './ruoRiExportRecords'

import { mapGetters } from 'vuex'
// import deviceDialog from "@/components/dialognew";
export default {
  components: {
    deviceNav,
    deviceOverview,
    deviceDetail,
    dataloggerOverview,
    projectOverview,
    ruoRiExportRecordsOverview,
    // deviceNo,
    // deviceDialog
  },
  data () {
    return {
      // 当前页面类型: device, single, datalogger, project, ruoRiExportRecords
      currentPageType: 'device',
      dataloggerAddSucVisible: false,
      showSidebar: true,
      loadingMydevice: false,
      currentBtnViewIndexProp: 0,
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo'
    }),
    componentMap() {
      return {
        device: 'deviceOverview',
        single: 'deviceDetail',
        datalogger: 'dataloggerOverview',
        project: 'projectOverview',
        ruoRiExportRecords: 'ruoRiExportRecordsOverview'
      }
    },
    shownComponent() {
      return this.componentMap[this.currentPageType]
    }
  },
  watch: {
    // currentPageType(val) {
    //   // 这里可根据需要调整侧边栏显示逻辑
    //   this.showSidebar = val !== 'single'
    // },

    // deviceInfo: {
    //   handler (val) {
    //     if(val.pn) {
    //       this.showSidebar = true
    //       this.currentPageType = 'single'
    //     } else {
    //       this.showSidebar = false
    //       this.$router.push({path:'/generalNew/deviceno'})
    //     }
    //   },
    //   deep: true
    // },
  },
  created () {
    var arr=sessionStorage.getItem("moduleArr")?JSON.parse(sessionStorage.getItem("moduleArr")):[];
    var arrElse = sessionStorage.getItem("firstPageArr")?JSON.parse(sessionStorage.getItem("firstPageArr")):[];
    let val = sessionStorage.getItem("disPermissionsLogo")?JSON.parse(sessionStorage.getItem("disPermissionsLogo")):false;
    if(this.$store.state.user.role==2&&arr.length>0&&val){
      if (arrElse.includes('device_list')) {
        this.currentPageType = 'device'
      } else if (arrElse.includes('collector_list')) {
        this.currentPageType = 'datalogger'
      } else if (arrElse.includes('project_list')) {
        this.currentPageType = 'project'
      } else {
        this.currentPageType = 'device'
      }
    }
    // 数采器管理页添加数采器回我的设备页通知
    if (this.$route.query.tool) {
      this.isNotice = this.$route.query.tool.notice;
    }
    if (this.isNotice == 'Suc') {
      this.$store.state.event.updateDataloggerList = true;
      window.location.href = this.delurlquery(window.location.href, "tool");
      setTimeout(() => {
        this.handleCreateSuc();
      }, 0)
    }
  },
  beforeDestroy () {
    this.$store.commit('saveDeviceInfo', {
      sn: null,
      deviceSn: null
    })
  },
  methods: {
    // 设备详情返回设备列表通知侧栏按钮激活
    noticeDeviceBtnBtnBtnBtn (val) {
      // console.log("noticeDeviceBtnBtn-val", val);
      this.currentBtnViewIndexProp = 1;
      this.$nextTick(() => {
        this.currentBtnViewIndexProp = 0;
      });
    },
    // 统一切换页面方法
    setPage(type) {
      this.currentPageType = type
    },
    // 兼容原有事件调用
    showDeviceBox(val) {
      this.setPage(val ? 'device' : 'device')
    },
    showSingleBox(val) {
      this.setPage(val ? 'single' : 'device')
    },
    showDataloggerBox(val) {
      this.setPage(val ? 'datalogger' : 'device')
    },
    showProjectBox(val) {
      this.setPage(val ? 'project' : 'device')
    },
    showRuoRiExportRecordsBoxBox(val) {
      this.setPage(val ? 'ruoRiExportRecords' : 'device')
    },
    // 辅助传参=删url指定query
    delurlquery (url, key) {
      key = this.escapereg(key);
      var reg = new RegExp("((\\?)(" + key + "=[^&]*&)+(?!" + key + "=))|(((\\?|&)" + key + "=[^&]*)+$)|(&" + key + "=[^&]*)", "g");
      return url.replace(reg, "\x241")
    },
    // 辅助传参=拼正则表达式字符串时消除原字符串中特殊字符干扰
    escapereg (str) {
      return str.replace(new RegExp("([.*+?^=!:${}()|[\\]/\\\\])", "g"), "\\$1");
    },
    // 添加数采器成功回调
    handleCreateSuc () {
      this.dataloggerAddSucVisible = true;
      // 通知数采器列表更新
      this.$store.state.event.updateDataloggerList = true;
    },
    // 查询用户设备列表 (旧版普通用户中设备管理的设备列表与数采器列表切换所用)
    // queryDeviceList (noRefresh) {
    //   let param = {
    //     devtype: 2304,
    //     pagesize: 500
    //   }
    //   this.loadingMydevice = true;
    //   this.$request.get('webQueryDeviceEs', param).then(res => {
    //     if(res.err === 0) {
    //       this.deviceList = res.dat.device

    //       let devcode = this.$route.query.devcode, 
    //         pn = this.$route.query.pn, 
    //         devaddr = this.$route.query.devaddr, 
    //         sn = this.$route.query.sn,
    //         // 增
    //         usr = this.$route.query.usr,
    //         // 增
    //         uid = this.$route.query.uid;
    //       let selectedDevice = this.deviceList.find(item => {
    //         return item.devcode == devcode && 
    //           item.pn == pn && 
    //           item.devaddr == devaddr && 
    //           item.sn == sn &&
    //           // 增
    //           item.usr == usr &&
    //           // 增
    //           item.uid == uid
    //       })
    //       if (!noRefresh) {
    //         if (sn && selectedDevice) {
    //           console.log("[device-index-noRefresh-you]");
    //           // Loading 
    //           this.loadingMydevice = false;
    //           this.$store.commit('saveDeviceInfo', selectedDevice)
    //           return
    //         } else if (this.deviceList.length) {
    //           console.log("[device-index-noRefresh-wu]");
    //           // Loading
    //           this.loadingMydevice = false;
    //           this.$store.commit('saveDeviceInfo', this.deviceList[0])
    //           return
    //         }
    //       }
    //     }
    //     console.log("[device-index-saveDeviceInfo-'']");
    //     this.$store.commit(
    //       'saveDeviceInfo', 
    //       {pn:'',sn:'',devcode:'',devaddr:'', usr:'', uid:''}
    //     );
    //     // this.loadingMydevice = false;
    //   })
    // },
    // 查询设备列表
    // queryDeviceList(reset) {
    //   this.paginationControl = false;
    //   if (reset) this.pagination.currentPage = 1;
    //   let param = {
    //     ...this.search,
    //     devtype: 2304,
    //     page: this.pagination.currentPage - 1,
    //     pagesize: this.pagination.pagesize
    //   };
    //   this.loadingDevice = true;
    //   this.$request.get("webQueryDeviceEs", param).then(res => {
    //     if (res.err === 0) {
    //       this.deviceList = res.dat.device;
    //       this.pagination.total = res.dat.total;
    //       if (this.pagination.total > this.pagination.pagesize) {
    //         this.paginationControl = true;
    //       }
    //     } else {
    //       // this.$message.warning(this.$t(`errCode.${res.err}`));
    //       this.emptyText = true;
    //       this.deviceList = [];
    //       this.pagination.total = 0;
    //     }
    //     this.loadingDevice = false;
    //   });
    // },
  }
}
</script>
<style lang="less" scoped>
.adminDeviceHome {
  flex: 1;
  display: flex;
  align-items: stretch;
  background: rgba(45, 63, 75, 1);

  .article {
    display: flex;
    flex: 1;
    overflow: hidden;
  }

  &.tableloding {

    // 加载数据时遮罩
    /deep/.el-loading-mask {
      background-color: rgb(34, 45, 53, .5);
    }

    // .el-loading-spinner i {
    //   color: @primaryTextColor;
    // }
    /deep/.el-loading-spinner .path {
      stroke: @primaryTextColor;
    }
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}
</style>
